<template>
  <div class="page-wrapper">
    <PageHeader></PageHeader>
    <div class="post-list-page">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索帖子"
          clearable
          @clear="handleSearch"
          @keyup.enter="handleSearch"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch" ></el-button>
        </el-input>
      </div>
  
      <div class="main-container">
        <!-- 左侧类别筛选菜单 -->
        <div class="category-menu">
          <el-menu
            default-active="all"
            class="menu"
            @select="handleCategorySelect"
          >
            <el-menu-item index="all">
              <i class="el-icon-menu"></i>
              <span>全部</span>
            </el-menu-item>
            <el-menu-item index="1">
              <i class="el-icon-star-off"></i>
              <span>宠物生活</span>
            </el-menu-item>
            <el-menu-item index="2">
              <i class="el-icon-service"></i>
              <span>宠物问答</span>
            </el-menu-item>
            <el-menu-item index="3">
              <i class="el-icon-s-opportunity"></i>
              <span>有趣知识</span>
            </el-menu-item>
            <el-menu-item index="4">
              <i class="el-icon-goods"></i>
              <span>好物分享</span>
            </el-menu-item>
          </el-menu>
        </div>
  
        <!-- 帖子列表 -->
        <div class="post-list-container">
          <div v-for="post in filteredPosts" :key="post.id" class="post-item">
            <!-- 帖子标题 -->
            <h2 class="post-title"  @click="goDetail(post.id)">{{ post.title }}</h2>
            <!-- 作者信息 -->
            <div class="author-info">
              <el-avatar :src="post.author.avatar" class="author-avatar"></el-avatar>
              <div class="author-details">
                <span class="author-name">{{ post.author.name }}</span>
                <span class="post-time">{{ post.createdAt }}</span>
              </div>
            </div>
  
            <!-- 帖子内容 -->
            <div class="post-content">
              <p  @click="goDetail(post.id)">{{ post.content }}</p>
            </div>
  
            <!-- 帖子图片（只展示第一张） -->
            <div v-if="post.images && post.images.length > 0" class="post-image" @click="goDetail(post.id)">
              <el-image :src="post.images[0]" fit="cover" class="image"></el-image>
            </div>
  
            <!-- 操作栏 -->
            <div class="action-bar">
              <el-button type="text" @click="goDetail(post.id)">
                <i class="el-icon-thumb"></i> {{ post.likes }} 点赞
              </el-button>
              <el-button type="text" @click="goDetail(post.id)">
                <i class="el-icon-chat-dot-round" ></i> {{ post.comments.length }} 评论
              </el-button>
            </div>
          </div>
        </div>
      </div>
  
      <!-- 固定发布按钮 -->
      <div class="floating-action-button" @click="handleCreatePost">
        <el-button type="primary" circle class="fab-icon">
          <i class="el-icon-plus"></i>
        </el-button>
        
      </div>
    </div>
    <PublicArticle v-model="pubDialog"></PublicArticle>
  </div>
  </template>
  
  <script>
  import PageHeader from '@/components/PageHeader.vue';
  import PublicArticle from '@/components/PublicArticle.vue';
  export default {
    components:{PageHeader,PublicArticle},
    data() {
      return {
        token: sessionStorage.getItem('token'),
        searchKeyword: "", // 搜索关键词
        selectedCategory: "all", // 当前选中的类别
        pubDialog:false,//发布弹窗
        posts: [
          {
            id: 1,
            title: "11",
            content: "11。",
            author: {
              id: 1,
              name: "11",
              avatar: "https://avatars.githubusercontent.com/u/12345678?v=4",
            },
            likes: 123,
            comments: [
              { id: 1, user: { id: 2, name: "用户A" }, content: "很棒！" },
              { id: 2, user: { id: 3, name: "用户B" }, content: "nice" },
            ],
            images: ["https://avatars.githubusercontent.com/u/45678901?", "https://avatars.githubusercontent.com/u/401?"],
            category: "1", // 帖子类别
            createdAt: "2023-10-01 10:00",
          },
          {
            id: 2,
            title: "22",
            content: "22",
            author: {
              id: 2,
              name: "22",
              avatar: "https://avatars.githubusercontent.com/u/23456789?v=4",
            },
            likes: 45,
            comments: [],
            images: [],
            category: "2", // 帖子类别
            createdAt: "2023-10-02 12:00",
          },
          {
            id: 3,
            title: "33",
            content: "33",
            author: {
              id: 3,
              name: "33",
              avatar: "https://avatars.githubusercontent.com/u/34567890?v=4",
            },
            likes: 78,
            comments: [],
            images: [],
            category: "3", // 帖子类别
            createdAt: "2023-10-03 14:00",
          },
        ],
      };
    },
    computed: {
      // 过滤后的帖子列表
      filteredPosts() {
        return this.posts.filter((post) => {
          // 按类别筛选
          const matchCategory =
            this.selectedCategory === "all" || post.category === this.selectedCategory;
          // 按关键词筛选
          const matchKeyword =
            !this.searchKeyword ||
            post.title.includes(this.searchKeyword) ||
            post.content.includes(this.searchKeyword);
          return matchCategory && matchKeyword;
        });
      },
    },
    methods: {
      // 点赞
      handleLike(post) {
        post.likes += 1;
        this.$message.success("点赞成功！");
      },
      // 评论
      handleComment(post) {
        this.$message.info(`评论帖子：${post.title}`);
      },
      // 发布帖子
      handleCreatePost() {
        if(this.token != null){
          this.pubDialog = true
        }else{
          this.$message.error('未登录，请先登录')
        }
       
      },
      // 搜索帖子
      handleSearch() {
        this.$message.info(`搜索关键词：${this.searchKeyword}`);
      },
      // 选择类别
      handleCategorySelect(index) {
        this.selectedCategory = index;
      },
      //跳转详情
      goDetail(postID){
        this.$router.push({path:'/detailComPage',query:{id:postID}})
      },
    },
  };
  </script>
  
  <style scoped>
  .page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* 调整Header容器样式 */
.page-wrapper >>> .page-header-container {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
}

.post-list-page {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  flex: 1;
}

  .post-list-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .search-bar {
    margin-bottom: 20px;
  }
  
  .main-container {
    display: flex;
  }
  
  .category-menu {
    width: 200px;
    margin-right: 20px;
  }
  
  .menu {
    border-right: none;
  }
  
  .post-list-container {
    flex: 1;
  }
  
  .post-item {
    margin-bottom: 30px;
    padding: 20px;
    border: 1px solid #eee;
    border-radius: 4px;
    background-color: #fff;
  }
  
  .post-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
  }
  
  .author-info {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .author-avatar {
    margin-right: 10px;
  }
  
  .author-details {
    display: flex;
    flex-direction: column;
  }
  
  .author-name {
    font-size: 14px;
    font-weight: bold;
  }
  
  .post-time {
    font-size: 12px;
    color: #999;
  }
  
  .post-content {
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 15px;
  }
  
  .post-image {
    margin-bottom: 15px;
  }
  
  .post-image .image {
    width: 100%;
    max-height: 300px;
    border-radius: 4px;
  }
  
  .action-bar {
    display: flex;
    gap: 10px;
  }
  
  .floating-action-button {
    position: fixed;
    right: 30px;
    bottom: 30px;
  }
  
  .fab-icon {
    width: 50px;
    height: 50px;
    font-size: 24px;
  }
  </style>